import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { CallWaiterService } from '@core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-call-waiter-indicator',
  standalone: true,
  templateUrl: './call-waiter-indicator.component.html',
  styleUrls: ['./call-waiter-indicator.component.scss'],
  host: {
    '[class.visible]': 'visible()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallWaiterIndicatorComponent {

  private readonly callWaiterService = inject(CallWaiterService);

  public readonly type = input.required<'main' | 'bill'>();

  public readonly mainActive = toSignal(this.callWaiterService.mainStatus$, {
    initialValue: true,
  });

  public readonly billActive = toSignal(this.callWaiterService.secondaryStatus$, {
    initialValue: false,
  });

  public readonly visible = computed(() => {
    return this.mainActive() || this.billActive();
  });

}
